(() => {
  'use strict';
  const explorer = document.querySelector('[data-why-explorer]');
  if (!explorer) return;
  const tablist = explorer.querySelector('.wy-feel-tabs');
  const tabs = [...explorer.querySelectorAll('[data-why-feel]')];
  const panels = [...explorer.querySelectorAll('[data-why-panel]')];
  // All five full panels remain readable and linked when JavaScript is unavailable.
  if (!tablist || !tabs.length || tabs.some(tab => !panels.some(panel => panel.dataset.whyPanel === tab.dataset.whyFeel))) return;
  tablist.setAttribute('role', 'tablist');
  tabs.forEach(tab => {
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-controls', `why-panel-${tab.dataset.whyFeel}`);
  });
  panels.forEach(panel => {
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', `why-tab-${panel.dataset.whyPanel}`);
    panel.tabIndex = 0;
  });

  function select(tab, revealTab = false) {
    const key = tab.dataset.whyFeel;
    tabs.forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });
    panels.forEach(panel => { panel.hidden = panel.dataset.whyPanel !== key; });
    if (revealTab) {
      // Reveal a horizontally offscreen tab without moving the page vertically.
      const bounds = tablist.getBoundingClientRect();
      const selected = tab.getBoundingClientRect();
      if (selected.left < bounds.left) tablist.scrollLeft += selected.left - bounds.left;
      else if (selected.right > bounds.right) tablist.scrollLeft += selected.right - bounds.right;
    }
  }

  function hashTab() {
    return tabs.find(tab => tab.getAttribute('href') === window.location.hash);
  }
  select(hashTab() || tabs[0], true);
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      select(tab, true);
    });
    tab.addEventListener('keydown', event => {
      let target;
      if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = tabs.length - 1;
      if (event.key === ' ') { event.preventDefault(); select(tab, true); return; }
      if (target === undefined) return;
      event.preventDefault();
      tabs[target].focus({ preventScroll: true });
      select(tabs[target], true);
    });
  });
  window.addEventListener('hashchange', () => { const tab = hashTab(); if (tab) select(tab, true); });
})();
